import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

const getCalendarEventsAPI = clubId => {
  return get(url.CALENDAR_EVENTS(clubId), {});
};

export { getCalendarEventsAPI };
